<script>
  import { ui } from '../stores';

  $: theme = $ui.theme || $ui.defaultTheme;
</script>

<header
  class="flex h-16 items-center space-between md:justify-center"
  style="background: {theme.header.background}">
  <a href="/">
    {@html theme.logo}
  </a>
</header>
